import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'conquerDesc'
})
export class ConquerDescPipe implements PipeTransform {

  private descMap = {
    'score': `Your Awair Score is a color-coded scale to let you know the quality of your air. It’s a 0 to 100 scale with 0 being poor air quality and 100 being the most healthy.`,

    'temp': `For best comfort and productivity, stick to two temperature ranges, depending on the time of year: <br>
    - Summer: 73°F - 79°F (22°C - 26°C)<br>
    - Winter: 68°F - 76°F (20°C - 24°C)`,

    'humid': `The most comfortable levels of humidity are between 20% and 60%.`,

    'co2': `Fresh air is the best way to keep CO₂ levels at bay. If you can, properly ventilate by opening a few windows or creating air flow with an HVAC system--but be sure to change your filters once every three months!`,

    'voc': `VOCs are extremely common ingredient in a variety of everyday items--from product packaging to paint.`,

    'dust': `Dust mites thrive in dark, moist areas with temperatures of 70°F or higher and humidity over 75%.`,

    'pm25': `You can reduce the levels of PM2.5 dust in your building by: <br>
    - Proper ventilation <br>
    - Installing air purifiers or filters <br>
       (with a MERV rating of 12 and above) <br>
    - Extending smoking boundaries outside <br>
       your building to at least 25 feet <br>
    - Changing your filters every 3 months`
  };

  transform(componentType: string): any {
    return this.descMap[componentType];
  }
}
